import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
import {StoreUpdateParamsType} from '../models/storeDetails';
import {StoreParamsType} from '../api/storesApi';

const storesSerializer = (
  pendingDetails: StoreUpdateParamsType
): StoreParamsType => {
  const output = JSON.parse(
    JSON.stringify({
      name: pendingDetails.name,
      status: pendingDetails.status,
      logo: pendingDetails.logo,
      hero_image: pendingDetails.heroImage,
      header_logo_type: pendingDetails.headerLogoType,
      hero_logo_visibility: pendingDetails.heroLogoVisibility,
      header_background_color: pendingDetails.bannerColor,
      banner_enabled: pendingDetails.bannerEnabled,
      banner_text: pendingDetails.bannerText,
      url_slug: pendingDetails.urlSlug
    })
  );
  return {
    ...omitBy(output, isUndefined)
  };
};

export default storesSerializer;
